// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#awsccc-sb-ux-c #awsccc-sb-a .awsccc-u-field{display:flex;flex-direction:column;gap:4px}", ""]);
// Exports
module.exports = exports;
